import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell, PlaceholderCard } from "@/components/DashboardShell";
import { SUPER_ADMIN_NAV } from "@/lib/nav";

export const Route = createFileRoute("/_authenticated/super-admin/subscriptions")({
  head: () => ({
    meta: [
      { title: "Subscription plans · Landoo Super Admin" },
      { name: "description", content: "Subscription plans — Landoo super admin console." },
    ],
  }),
  component: () => (
    <DashboardShell title="Subscription plans" role="Super Admin" items={SUPER_ADMIN_NAV}>
      <PlaceholderCard
        title="Subscription plans"
        description="Super admin management surface for Subscription plans."
      />
    </DashboardShell>
  ),
});
